import { HUBSPOT_COOKIE_KEY } from '@cast/constants';
import { HubspotFormBody, HubspotObject } from '@cast/types';
import { getCookie } from '@cast/utils';

export const REPORTING_CONTACT_SALES_PAGE_NAME = 'Reporting Contact Sales';

export const SUCCESS_TOAST = 'Request sent. Our team will follow up shortly.';

export const ERROR_TOAST =
  'Failed to send your request. Please try again later.';

export type ReportingContactSalesPayload = {
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  country?: string;
  title?: string;
  orgId: string;
  orgName: string;
};

export const splitDisplayName = (
  name?: string,
  firstNameFallback?: string
): { firstName: string; lastName: string } => {
  const trimmed = name?.trim() ?? '';
  if (!trimmed) {
    return { firstName: firstNameFallback?.trim() ?? '', lastName: '' };
  }
  const spaceIdx = trimmed.indexOf(' ');
  if (spaceIdx === -1) {
    return {
      firstName: firstNameFallback?.trim() || trimmed,
      lastName: '',
    };
  }
  return {
    firstName: trimmed.slice(0, spaceIdx).trim(),
    lastName: trimmed.slice(spaceIdx + 1).trim(),
  };
};

const field = (
  name: string,
  value: string
): HubspotFormBody['fields'][number] => ({
  objectTypeId: HubspotObject.CONTACT,
  name,
  value,
});

export const buildReportingContactSalesFormBody = (
  payload: ReportingContactSalesPayload,
  context: { pageUri: string; pageName?: string; hutk?: string }
): HubspotFormBody => {
  const fields = [
    field('email', payload.email),
    field('firstname', payload.firstName),
    field('lastname', payload.lastName),
    field('company', payload.company),
    field('orgid', payload.orgId),
    field('orgname', payload.orgName),
  ];

  if (payload.country?.trim()) {
    fields.push(field('country', payload.country.trim()));
  }
  if (payload.title?.trim()) {
    fields.push(field('title', payload.title.trim()));
  }

  const hutk = context.hutk ?? getCookie(HUBSPOT_COOKIE_KEY) ?? undefined;

  return {
    submittedAt: Date.now(),
    fields,
    context: {
      ...(hutk ? { hutk } : {}),
      pageUri: context.pageUri,
      pageName: context.pageName ?? REPORTING_CONTACT_SALES_PAGE_NAME,
    },
  } as HubspotFormBody;
};
